import { render } from "./ZoomButtons.vue?vue&type=template&id=6d517f88"
import script from "./ZoomButtons.vue?vue&type=script&lang=js"
export * from "./ZoomButtons.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__